// 固定来源及直接静态依赖，不在运行时读取兄弟仓；原文/安装器字节不改。
export const skillSource={ref:'79ab967a597c9f546d275b7c6feb8ef5fa211615',manifest:'desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/content/project-installers.json',manifestBlob:'ef9dec1cfd9ae272a26b81c86892bcc6fc469190',manifestSHA256:'c540fe127d1f1e98313891b37a7bfe29664c9ec017f7b402312eb5abd847ecb9'} as const;
export const skillCategories=["全部", "内容创作", "办公文档", "资料调研", "自动操作"] as const;
export const projectCategories=[
  "内容创作", "内容创作", "内容创作", "内容创作", "内容创作", "内容创作", "内容创作",
  "资料调研", "自动操作", "自动操作", "自动操作", "自动操作", "办公文档", "办公文档",
  "办公文档", "办公文档", "办公文档", "自动操作", "自动操作", "内容创作",
] as const;
export const skillInstallers={
  "projects": [
    {
      "number": "01",
      "title": "生成文案",
      "description": "整理标题、推广文案和发布草稿，按你的资料与风格输出。",
      "filename": "01 生成文案-安装包.md",
      "path": "downloads/project-01.md",
      "prompt": "请安装我上传的《01 生成文案-安装包.md》，自动为“生成文案”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "02",
      "title": "生成图片",
      "description": "按画面用途准备提示词，连接生图服务后生成并保存图片。",
      "filename": "02 生成图片-安装包.md",
      "path": "downloads/project-02.md",
      "prompt": "请安装我上传的《02 生成图片-安装包.md》，自动为“生成图片”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "03",
      "title": "处理音视频",
      "description": "裁剪音视频、提取音轨、转换格式，保留原件并另存成品。",
      "filename": "03 处理音视频-安装包.md",
      "path": "downloads/project-03.md",
      "prompt": "请安装我上传的《03 处理音视频-安装包.md》，自动为“处理音视频”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "04",
      "title": "语音转文字",
      "description": "将录音整理成逐字稿、会议摘要或带时间的笔记。",
      "filename": "04 语音转文字-安装包.md",
      "path": "downloads/project-04.md",
      "prompt": "请安装我上传的《04 语音转文字-安装包.md》，自动为“语音转文字”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "05",
      "title": "文字转语音",
      "description": "把朗读稿做成配音，按需要选择声音、语速和音频格式。",
      "filename": "05 文字转语音-安装包.md",
      "path": "downloads/project-05.md",
      "prompt": "请安装我上传的《05 文字转语音-安装包.md》，自动为“文字转语音”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "06",
      "title": "带货短视频",
      "description": "用产品照片、视频和卖点，制作适合发布的带货短片。",
      "filename": "06 带货短视频-安装包.md",
      "path": "downloads/project-06.md",
      "prompt": "请安装我上传的《06 带货短视频-安装包.md》，自动为“带货短视频”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "07",
      "title": "长视频与字幕",
      "description": "按章节剪辑视频，制作可继续修改的字幕与成片。",
      "filename": "07 长视频与字幕-安装包.md",
      "path": "downloads/project-07.md",
      "prompt": "请安装我上传的《07 长视频与字幕-安装包.md》，自动为“长视频与字幕”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "08",
      "title": "抓取网页",
      "description": "从网页或网址提取指定内容，整理成带来源的表格。",
      "filename": "08 抓取网页-安装包.md",
      "path": "downloads/project-08.md",
      "prompt": "请安装我上传的《08 抓取网页-安装包.md》，自动为“抓取网页”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "09",
      "title": "操作网站",
      "description": "按条件查询、筛选网站信息，保存结果和来源链接。",
      "filename": "09 操作网站-安装包.md",
      "path": "downloads/project-09.md",
      "prompt": "请安装我上传的《09 操作网站-安装包.md》，自动为“操作网站”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "10",
      "title": "操作飞书",
      "description": "整理飞书文档或表格内容，制作导入文件或连接后写入。",
      "filename": "10 操作飞书-安装包.md",
      "path": "downloads/project-10.md",
      "prompt": "请安装我上传的《10 操作飞书-安装包.md》，自动为“操作飞书”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "11",
      "title": "操作企业微信",
      "description": "整理企业微信消息草稿，确认渠道与授权后再发送。",
      "filename": "11 操作企业微信-安装包.md",
      "path": "downloads/project-11.md",
      "prompt": "请安装我上传的《11 操作企业微信-安装包.md》，自动为“操作企业微信”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "12",
      "title": "微信远程控制",
      "description": "核对从微信发起 Codex 任务的接入条件与可行方案。",
      "filename": "12 微信远程控制-安装包.md",
      "path": "downloads/project-12.md",
      "prompt": "请安装我上传的《12 微信远程控制-安装包.md》，自动为“微信远程控制”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "13",
      "title": "Obsidian 知识库",
      "description": "整理本地笔记，建立主题索引和笔记之间的链接。",
      "filename": "13 Obsidian 知识库-安装包.md",
      "path": "downloads/project-13.md",
      "prompt": "请安装我上传的《13 Obsidian 知识库-安装包.md》，自动为“Obsidian 知识库”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "14",
      "title": "处理 Word",
      "description": "整理和排版文字、图片，制作可继续编辑的 Word 文档。",
      "filename": "14 处理 Word-安装包.md",
      "path": "downloads/project-14.md",
      "prompt": "请安装我上传的《14 处理 Word-安装包.md》，自动为“处理 Word”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "15",
      "title": "处理 Excel",
      "description": "清洗表格、汇总数据、编写公式，生成可编辑的 Excel。",
      "filename": "15 处理 Excel-安装包.md",
      "path": "downloads/project-15.md",
      "prompt": "请安装我上传的《15 处理 Excel-安装包.md》，自动为“处理 Excel”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "16",
      "title": "处理 PPT",
      "description": "按资料与演讲需求制作可编辑的 PPT 和讲解提纲。",
      "filename": "16 处理 PPT-安装包.md",
      "path": "downloads/project-16.md",
      "prompt": "请安装我上传的《16 处理 PPT-安装包.md》，自动为“处理 PPT”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "17",
      "title": "处理 PDF",
      "description": "提取 PDF 文字，按需要合并、拆分和选择页面。",
      "filename": "17 处理 PDF-安装包.md",
      "path": "downloads/project-17.md",
      "prompt": "请安装我上传的《17 处理 PDF-安装包.md》，自动为“处理 PDF”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "18",
      "title": "自动操作浏览器",
      "description": "连接浏览器后，按你的条件执行查询和指定操作。",
      "filename": "18 自动操作浏览器-安装包.md",
      "path": "downloads/project-18.md",
      "prompt": "请安装我上传的《18 自动操作浏览器-安装包.md》，自动为“自动操作浏览器”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "19",
      "title": "自动操作电脑",
      "description": "明确应用、目录与权限后，执行电脑操作并核对结果。",
      "filename": "19 自动操作电脑-安装包.md",
      "path": "downloads/project-19.md",
      "prompt": "请安装我上传的《19 自动操作电脑-安装包.md》，自动为“自动操作电脑”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    },
    {
      "number": "20",
      "title": "可修改的视频",
      "description": "把文案、配色和时长做成可修改配置，输出视频与工程。",
      "filename": "20 可修改的视频-安装包.md",
      "path": "downloads/project-20.md",
      "prompt": "请安装我上传的《20 可修改的视频-安装包.md》，自动为“可修改的视频”新建独立的 Codex 项目，并创建“使用说明｜先从这里开始”聊天。安装好后只告诉我怎么发资料、怎么提需求，给我一段可复制的话术，等我发真实材料后再开始。"
    }
  ],
  "bundle": {
    "title": "20 个实战项目集中包",
    "description": "一次安装 20 个相互独立的项目，每个都有使用说明。",
    "filename": "20个实战项目-集中安装包.md",
    "path": "downloads/all-projects.md",
    "prompt": "请安装我上传的《20个实战项目-集中安装包.md》，自动新建或复用 20 个独立 Codex 项目，每个都创建或复用“使用说明｜先从这里开始”聊天，告诉我怎么发资料、怎么提需求，并给出可复制的话术。安装后等我发真实材料，不生成案例。保留已有资料和成果，遇到修改冲突先说明。请按包内流程确认项目和使用说明实际完成，再给我清单；不用我手动新建项目。"
  }
} as const;
export const skillInstallerAssets=[
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-01.md",
    "blob": "28734a06f7f4c3b15687d406160d97d43035e93b",
    "sha256": "a43e57ec19b16b426a51b26c9f50d8d01083b2c4768a61f9402fbd436963bb71",
    "bytes": 11619,
    "target": "apps/web/public/mac/skills/project-01.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-02.md",
    "blob": "d403acaa4c9eaa7f911ce0dd29ecbe410ccc44f2",
    "sha256": "ae88c299011261064eab340a1e22de66a4bedae018f1aaba5257dae0d8ef25e4",
    "bytes": 12614,
    "target": "apps/web/public/mac/skills/project-02.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-03.md",
    "blob": "c1ddf1452233a600f71e909947be17c28f7c380f",
    "sha256": "7839134c7e25eb587f32581a7cde9eb3195cc49cb7c516372ca10ee90736fb02",
    "bytes": 11843,
    "target": "apps/web/public/mac/skills/project-03.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-04.md",
    "blob": "ccdd4d006fb884f0d94fb55d098202cc1672c40b",
    "sha256": "e22ed497bb8af5016a5b5c3b2dd170f50dcabfcf0a73042da56a656f2146ef45",
    "bytes": 12140,
    "target": "apps/web/public/mac/skills/project-04.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-05.md",
    "blob": "0ab0ff2bba7ccac844602da51e8308ecea53238d",
    "sha256": "e7c47756760950cfdbd644ed832f3cc2686fcde59e78bbbc5360386894e0bbbf",
    "bytes": 12118,
    "target": "apps/web/public/mac/skills/project-05.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-06.md",
    "blob": "e5cb563039c39e414745118f3d213bcac0564b93",
    "sha256": "30322296f3a0212f80036662d35d978d683abbe28f879f3da5cbbd0337f32277",
    "bytes": 12628,
    "target": "apps/web/public/mac/skills/project-06.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-07.md",
    "blob": "604bd713dce90ab97f419562382bd7ff1242b666",
    "sha256": "4b402519daa7bef55cfa11ca1a29ebf18b7b4acd8a4f58530791eccbbdb64b96",
    "bytes": 12562,
    "target": "apps/web/public/mac/skills/project-07.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-08.md",
    "blob": "4949d2ff68380fd4ac867b06212b03bf0b9b4dd5",
    "sha256": "1dedcfd6289d67374a97574de6ca4da010a3b2bdd9805234f3cec5b6058da5a7",
    "bytes": 12418,
    "target": "apps/web/public/mac/skills/project-08.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-09.md",
    "blob": "42a47ed4a0726123d64714e11ddec0546b01d186",
    "sha256": "410705f7010a8294bbd7134adf6de40bd6cf29013d1d45b16818ebad1487aa93",
    "bytes": 12301,
    "target": "apps/web/public/mac/skills/project-09.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-10.md",
    "blob": "636e4354b592996fa62a3284439bc2c51cd9eebc",
    "sha256": "77fb8d9cc67b33e1b34ef059efc55fd02143ab12a8b67dd270af02452d544ae3",
    "bytes": 12604,
    "target": "apps/web/public/mac/skills/project-10.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-11.md",
    "blob": "c4d752b85b67dbd4d1db6f293711f9249de70f3e",
    "sha256": "e4145474d534553d4e33e7eff15b541896580fd0f9e25605a4746656269b5e6f",
    "bytes": 12425,
    "target": "apps/web/public/mac/skills/project-11.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-12.md",
    "blob": "25bd33d5da6c0d69794d30ab52427eb0b6258dbf",
    "sha256": "43fcabf4a5fc0128e5bd31ba2dd2ce036cba591f2f6dcf960a494feeff7070f9",
    "bytes": 12957,
    "target": "apps/web/public/mac/skills/project-12.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-13.md",
    "blob": "47621e27c3d441cdea1c0ecefdb9052910e6e6a3",
    "sha256": "06e7d270497d8cec8ce415eb0a996a62379f4a1709d5bf46dfcd05be6012876f",
    "bytes": 12523,
    "target": "apps/web/public/mac/skills/project-13.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-14.md",
    "blob": "e1f7a396265e62bc9a6b569b2a67c88c7d8a5678",
    "sha256": "7ddd7a0174696a8164e96af0d799618e52ebf6a94ea526a807b66902f94a241a",
    "bytes": 12113,
    "target": "apps/web/public/mac/skills/project-14.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-15.md",
    "blob": "81ade80a5a0f257c7f9b3533ef6ee9a5b88dce5c",
    "sha256": "255554d3945aeafcd13fc6e03cfe80762ec1f96a0fd754ed3b499cec12b7e355",
    "bytes": 12191,
    "target": "apps/web/public/mac/skills/project-15.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-16.md",
    "blob": "dd208ba574b4faa1f7d6a079c5106bec182ab0b7",
    "sha256": "dd8fe2ba7d9df4db4ff7e218b23ffccf379a4fbd173f3cb0ffeab0f14dfadb5e",
    "bytes": 12185,
    "target": "apps/web/public/mac/skills/project-16.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-17.md",
    "blob": "e453864838aa5ba945f4f3f901b92d559ec04ee9",
    "sha256": "4cde1666775a2d5433048d35b9d13aadd24b4afde50d7bc157114aa7f73eedcb",
    "bytes": 12141,
    "target": "apps/web/public/mac/skills/project-17.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-18.md",
    "blob": "93587463f69f939c71eb8b55f2144175a0688666",
    "sha256": "48a4b44918709df7742eeb17c6351f45d5588286c21f023515f63867e9ad1f63",
    "bytes": 12351,
    "target": "apps/web/public/mac/skills/project-18.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-19.md",
    "blob": "6d69c986a4b74fd087ef571f080fc05ad88854a0",
    "sha256": "21c4634e3aba30ff34d21d496fa2237f31aab5f6c913c42a401e2c579ae3d94a",
    "bytes": 12357,
    "target": "apps/web/public/mac/skills/project-19.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/project-20.md",
    "blob": "93d5bd200afc39c415bd7fc405faf8ac33bdeaf1",
    "sha256": "caf87b833f16cdb16b71fa59c35a6a1c8b2442c34080d6bdb8b766820ff02e17",
    "bytes": 12534,
    "target": "apps/web/public/mac/skills/project-20.md"
  },
  {
    "source": "desktop/codex-zzy-assistant/apps/codex-plus-manager/public/tutorial-center/downloads/all-projects.md",
    "blob": "b7b77ec68ce731219bdd96fa2e955c30239f7bf6",
    "sha256": "b25567676c12e8833b819ff56060d7ec9c54d190828379b61b14c640a3bad957",
    "bytes": 109679,
    "target": "apps/web/public/mac/skills/all-projects.md"
  }
] as const;
export const skillSearchEnglish={
  "生成文案": "Write copy",
  "整理标题、推广文案和发布草稿，按你的资料与风格输出。": "Create headlines, promotional copy, and publishing drafts based on your materials and style.",
  "生成图片": "Generate images",
  "按画面用途准备提示词，连接生图服务后生成并保存图片。": "Prepare prompts for your intended use, then connect an image service to generate and save images.",
  "处理音视频": "Edit audio & video",
  "裁剪音视频、提取音轨、转换格式，保留原件并另存成品。": "Trim audio and video, extract audio tracks, and convert formats while saving results separately from the originals.",
  "语音转文字": "Transcribe audio",
  "将录音整理成逐字稿、会议摘要或带时间的笔记。": "Turn recordings into transcripts, meeting summaries, or timestamped notes.",
  "文字转语音": "Text to speech",
  "把朗读稿做成配音，按需要选择声音、语速和音频格式。": "Turn scripts into voiceovers with your choice of voice, speaking speed, and audio format.",
  "带货短视频": "Product short videos",
  "用产品照片、视频和卖点，制作适合发布的带货短片。": "Create product videos ready to publish using product photos, clips, and selling points.",
  "长视频与字幕": "Long videos & subtitles",
  "按章节剪辑视频，制作可继续修改的字幕与成片。": "Edit videos by chapter and create finished videos with editable subtitles.",
  "抓取网页": "Extract web content",
  "从网页或网址提取指定内容，整理成带来源的表格。": "Extract selected content from web pages and organize it into tables with source links.",
  "操作网站": "Work with websites",
  "按条件查询、筛选网站信息，保存结果和来源链接。": "Search and filter website information using your criteria, then save the results and source links.",
  "操作飞书": "Work with Feishu",
  "整理飞书文档或表格内容，制作导入文件或连接后写入。": "Organize Feishu documents and spreadsheets, prepare import files, or connect to write content directly.",
  "操作企业微信": "Work with WeCom",
  "整理企业微信消息草稿，确认渠道与授权后再发送。": "Prepare WeCom message drafts and send them after confirming the channel and authorization.",
  "微信远程控制": "Remote tasks via WeChat",
  "核对从微信发起 Codex 任务的接入条件与可行方案。": "Check the requirements and available approaches for starting Codex tasks from WeChat.",
  "Obsidian 知识库": "Obsidian knowledge base",
  "整理本地笔记，建立主题索引和笔记之间的链接。": "Organize local notes, build topic indexes, and connect related notes.",
  "处理 Word": "Work with Word",
  "整理和排版文字、图片，制作可继续编辑的 Word 文档。": "Organize and format text and images to create editable Word documents.",
  "处理 Excel": "Work with Excel",
  "清洗表格、汇总数据、编写公式，生成可编辑的 Excel。": "Clean spreadsheets, summarize data, and write formulas to create editable Excel files.",
  "处理 PPT": "Create presentations",
  "按资料与演讲需求制作可编辑的 PPT 和讲解提纲。": "Create editable PowerPoint presentations and speaking outlines based on your materials and presentation needs.",
  "处理 PDF": "Work with PDFs",
  "提取 PDF 文字，按需要合并、拆分和选择页面。": "Extract PDF text and merge, split, or select pages as needed.",
  "自动操作浏览器": "Automate your browser",
  "连接浏览器后，按你的条件执行查询和指定操作。": "Connect a browser to run searches and perform the actions you specify.",
  "自动操作电脑": "Automate your computer",
  "明确应用、目录与权限后，执行电脑操作并核对结果。": "Confirm the apps, folders, and permissions, then carry out computer tasks and check the results.",
  "可修改的视频": "Editable videos",
  "把文案、配色和时长做成可修改配置，输出视频与工程。": "Make copy, colors, and duration configurable, then export the video and project files.",
  "内容创作": "Content creation",
  "资料调研": "Research",
  "自动操作": "Automation",
  "办公文档": "Office documents"
} as Record<string,string>;
export type SkillInstaller=typeof skillInstallers.projects[number]|typeof skillInstallers.bundle;
export function skillDownload(item:SkillInstaller){return skillInstallerAssets.find(asset=>asset.source.endsWith('/'+item.path))!}
export function filterSkills(query:string,category:string){const search=query.trim().toLocaleLowerCase();return skillInstallers.projects.filter((item,index)=>(category==='全部'||projectCategories[index]===category)&&[item.number,item.title,item.description,projectCategories[index],skillSearchEnglish[item.title],skillSearchEnglish[item.description],skillSearchEnglish[projectCategories[index]!]].join(' ').toLocaleLowerCase().includes(search))}
